import AntdFeatherIcon from '@/components/_common/AntdFeatherIcon';
import { Button, Col, Row, Table, Typography } from 'antd';
import { ArrowLeft, Send } from 'react-feather';
import { FormattedMessage } from 'react-intl';
import { CrmReceiverCustomer } from '../ShippingOptionsCustomerTable';
import { useEffect, useState } from 'react';
import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
} from '@/components/_common';
import { useDefaultEmptyFieldError, useWindowSize } from '@/hooks';
import formatterNumber from '@/utils/number/formatterNumber';

interface Props {
  onPrev(): void;
  loading?: boolean;
  customers: CrmReceiverCustomer[];
}

const ShippingOptionsSumarySend: React.FC<Props> = ({
  onPrev,
  loading,
  customers,
}) => {
  const ruleRequired = useDefaultEmptyFieldError();
  const { isMobile } = useWindowSize();

  const [customerConfig, setCustomerConfig] = useState({
    customersSelecteds: 0,
    customersWithoutEmail: 0,
    totalToSend: 0,
  });

  useEffect(() => {
    const customersSelecteds = customers.length;
    const customersWithoutEmail = customers.filter(
      (item) => !item?.customer?.email,
    ).length;

    setCustomerConfig({
      customersSelecteds,
      customersWithoutEmail,
      totalToSend: customersSelecteds - customersWithoutEmail,
    });
  }, [customers]);

  return (
    <>
      <Typography.Title level={4}>Empresa de envio</Typography.Title>
      <FloatingFormItem
        name="companyId"
        label="Selecionar empresa"
        rules={[ruleRequired]}
      >
        <CompaniesInfiniteSelectField allowClear />
      </FloatingFormItem>

      <Table
        style={{ marginTop: 24 }}
        pagination={false}
        dataSource={[customerConfig]}
        columns={[
          {
            dataIndex: 'customersSelecteds',
            title: 'Clientes selecionados',
            width: 160,
            ellipsis: true,
            render: (value) =>
              formatterNumber(value, { minimumFractionDigits: 0 }),
          },
          {
            dataIndex: 'customersWithoutEmail',
            title: 'Clientes sem emails',
            width: 160,
            ellipsis: true,
            render: (value) =>
              formatterNumber(value, { minimumFractionDigits: 0 }),
          },
          {
            dataIndex: 'totalToSend',
            title: 'Total a ser enviado',
            width: 160,
            ellipsis: true,
            render: (value) =>
              formatterNumber(value, { minimumFractionDigits: 0 }),
          },
        ]}
        scroll={{ x: true }}
      />

      <Row gutter={[24, 24]} style={{ marginTop: 24 }} justify="end">
        <Col span={isMobile ? 24 : undefined}>
          <Button onClick={onPrev} block>
            <AntdFeatherIcon icon={<ArrowLeft />} size={12} />
            <FormattedMessage id="commons.modal.button.back" />
          </Button>
        </Col>

        <Col span={isMobile ? 24 : undefined}>
          <Button htmlType="submit" type="primary" loading={loading} block>
            <AntdFeatherIcon icon={<Send />} size={12} />
            <span>Enviar</span>
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default ShippingOptionsSumarySend;
